var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex flex-wrap"},[_c('section',{staticClass:"w-full md:w-7/12 lg:w-8/12 xl:w-9/12 mb-4 md:pr-8"},[_vm._t("default")],2),_c('aside',{staticClass:"w-full md:w-5/12 lg:w-4/12 xl:w-3/12 mb-4"},[_vm._t("aside")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }